import React, {
  useState,
  useEffect,
  useRef,
  Dispatch,
  SetStateAction,
} from "react";
import styled from "styled-components";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import logo from "../assets/logo.svg";

interface WrapperInterface {
  fitHeight: boolean;
}

const Wrapper = styled.div<WrapperInterface>`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  backdrop-filter: blur(10px);
  background-position: center;
  background-repeat: no-repeat;
  box-sizing: content-box;
  border: 1px solid red;

  img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 40%;
    height: ${(props) => props.fitHeight ? '100%' : '70%'};
    border-radius: 16px;
    object-fit: cover;
    z-index: 1;
  }

  .logo {
    width: 248px !important;
    height: 212px !important;
  }

  .left-arrow {
    position: absolute;
    top: 50%;
    left: 200px;
    font-size: 60px;
    cursor: pointer;
    z-index: 2;
  }

  .right-arrow {
    position: absolute;
    top: 50%;
    right: 200px;
    font-size: 60px;
    cursor: pointer;
    z-index: 3;
  }

  @media screen and (max-width: 940px) {
    img {
      width: 70%;
      height: 50%;
    }

    .left-arrow {
      position: absolute;
      top: 50%;
      left: 5px;
    }

    .right-arrow {
      position: absolute;
      top: 50%;
      right: 5px;
    }
  }
`;

const ModalSlideshow = ({
  images,
  index,
  _setOpenModal,
  fitHeight = false,
}: {
  images: string[];
  index: number;
  _setOpenModal: Dispatch<SetStateAction<boolean>>;
  fitHeight?: boolean;
}) => {
  const [current, _setCurrent] = useState<number>(index);
  const len: number = images.length - 1;

  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const hanldeClickOutside = (event: any) => {
      if (ref.current && !ref.current?.contains(event.target)) {
        _setOpenModal(false);
      }
    };
    document.addEventListener("mousedown", hanldeClickOutside);
    return () => {
      document.removeEventListener("mousedown", hanldeClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref]);

  const _decrementIndex = () => {
    let result = current - 1;

    if (result > len) _setCurrent(0);
    else if (result < 0) _setCurrent(len);
    else _setCurrent(result);
  };

  const _incrementIndex = () => {
    let result = current + 1;

    if (result > len) _setCurrent(0);
    else if (result < 0) _setCurrent(len);
    else _setCurrent(result);
  };

  return (
    <Wrapper fitHeight={fitHeight}>
      {
        <>
          <span ref={ref}>
            <ArrowBackIosNewIcon
              className="left-arrow"
              onClick={_decrementIndex}
            />
            <img
              src={images.at(current)}
              alt="house-pics"
              key={current}
              className={images.at(current) === logo ? "logo" : ""}
            />
            <ArrowForwardIosIcon
              className="right-arrow"
              onClick={_incrementIndex}
            />
          </span>
        </>
      }
    </Wrapper>
  );
};

export default ModalSlideshow;
